import React, { useState } from 'react';
import homebackgroundimg from './../image/Career_banner.mp4';
import { Link } from 'react-router-dom';
import { FaHandsHelping, FaHeartbeat, FaInstagram, FaLinkedinIn} from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { BadgeCheck, GraduationCap } from 'lucide-react';

const CareersAtNexify = ({ title }) => {
  const [filters, setFilters] = useState({
    searchQuery: '',
    location: '',
  });

  const isBusinessSolution = title === "Careers at Nexify";
  const isconsultant = title === "Why We’re Different";

  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">

      <Helmet>
        <title>Careers at Nexify Infosystem</title>
        <meta name="description" content="Join our team at Nexify and take your career to the next level. Explore exciting opportunities and apply today!" />
        <meta name="keywords" content="careers, jobs, Nexify, hiring, employment" />
      </Helmet>
       <div className="w-full h-[440px] relative flex items-center justify-center">
              {/* Video Background */}
              <video
                className="absolute top-0 left-0 w-full h-full object-cover"
                src={homebackgroundimg}
                autoPlay
                loop
                muted
              />
      
              {/* Content */}
              <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
                <div
                  className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[80%] lg:ml-14 border border-white/20 rounded-lg relative"
                  style={{
                    animation: "slideUp 1s ease-in-out forwards",
                    animationDelay: "2s",
                  }}
                >
                   <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
                    Nexify Careers
                  </h1>
                  <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
                    Advancing careers, unlocking opportunities, shaping futures.
                  </h2>
                </div>
              </div>
            </div>

      <div className="w-full max-w-[1320px] px-4 mx-auto lg:mt-20 mt-10 mb-5">        
        <div className='flex flex-col gap-6'>
        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-36 h-36 bg-[#cce5ff] rounded-full mr-6">
            <FaHandsHelping className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[40px] text-[30px] font-[700] text-[#0e55a8] leading-[1.25] mb-2"> Why Nexify Stands Out: Career Growth, Work-Life Balance, and Community Impact</h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] mb-4 text-justify">
            At Nexify, we are dedicated to fostering professional growth and career advancement in a fast-paced environment.
              We prioritize our employees’ well-being by promoting a healthy work-life balance, offering vacation time, holidays, birthdays off, and philanthropic days.
              We also encourage team bonding through various team-building events.
              Our commitment to both personal and professional development ensures that our employees thrive in both their careers and personal lives.
            </p>
          </div>
        </div>


        <div className="bg-white flex flex-col md:flex-row items-center p-6 ">
          <div className="flex items-center justify-center w-36 h-36 bg-[#cce5ff] rounded-full mr-6">
            <FaHeartbeat className="text-[#005eb8] text-5xl" />
          </div>
          <div className="flex-1">
            <h3 className="lg:text-[40px] text-[30px] font-[700] text-[#0e55a8] leading-[1.25] mb-2"> Putting People First: A Commitment to Your Well-Being</h3>
            <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8] mb-4 text-justify">
            At Nexify, we prioritize making everyone feel valued, respected, and supported. Our competitive compensation package includes health, dental, and vision insurance, a 401k retirement plan (U.S.) or Registered Retirement Plan (Canada), vacation and holidays, and life insurance. We also offer short- and long-term disability coverage, training and advancement opportunities, and perks such as gym memberships, birthdays off, and car/cell phone allowances for sales roles.
            </p>
          </div>
        </div>
        
      </div>


        <div className="lg:w-[850px] w-full px-4 mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 justify-center items-center">
  {/* Experienced Professionals Section */}
  <div className="bg-white p-6 shadow-md text-center flex flex-col items-center">
  <div className="flex items-center justify-center w-20 h-20 mb-3 bg-[#ff9416] rounded-full">
        <BadgeCheck size={40} className="text-white" />
      </div>
    <h4 className="mb-2 text-[#ff9416] text-[22px] leading-[1.8] font-[500]">
      Experienced Professionals
    </h4>
    <p className="mb-4 text-[16px] leading-[1.8] text-[#6d6d70] font-[400]">
      Even if you’ve been in the workforce for a few years, we offer opportunities for candidates with more experience including positions in sales, recruiting, consulting, corporate, and management.
    </p>
    <Link
      to="/experienced-professionals"
      className="bg-[#fb9d3d] hover:bg-[#ffac43] text-white text-[14px] uppercase font-semibold py-3 px-6 shadow-lg transition-all duration-300"
       >
      Take A New Path
    </Link>
  </div>

  {/* Students and New Grads Section */}
  <div className="bg-white p-6  shadow-md text-center flex flex-col items-center">
  <div className="flex items-center justify-center w-20 h-20 mb-3 bg-[#ff9416] rounded-full">
        <GraduationCap size={40} className="text-white" />
      </div>
    <h4 className="mb-2 text-[#ff9416] text-[22px] leading-[1.8] font-[500]">
      Students and New Grads
    </h4>
    <p className="mb-4 text-[16px] leading-[1.8] text-[#6d6d70] font-[400]">
      Getting your foot in the door can be tough, but we provide opportunities for entry-level and recent grads in sales, recruiting, and corporate, and provide you with the training and support you’ll need.
    </p>
    <Link
      to="/students-new-grads"
      className="bg-[#fb9d3d] hover:bg-[#ffac43] text-white text-[14px] uppercase font-semibold py-3 px-6 shadow-lg transition-all duration-300"
      >
      Start your Career
    </Link>
  </div>
</div>



        <div className="bg-white flex flex-col md:flex-row lg:p-12 p-6 w-full max-w-[1320px] lg:text-center md:shadow-lg md:rounded-lg gap-20 lg:mb-10 lg:mt-10 justify-center items-center">
          {/* Left Side */}
          <div className="lg:mb-2 md:mb-0 lg:text-center">
            <h3 className="lg:text-3xl text-xl font-[500] text-black mt-2">Follow us for updates at #NexifyCareers</h3>
          </div>

          {/* Social Media Icons */}
          <div className="flex lg:justify-center lg:items-center lg:gap-6 gap-3 lg:mt-4 mt-[-40px] md:mt-0 ">

            <a
              href="https://www.linkedin.com/company/nexify-infosystems-llc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw=="
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CareersAtNexify;
